export default __webpack_public_path__ + "static/media/delete.e7c2692f.svg";